var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-layout"},[_c('app-header'),_c('app-navbar'),_c('main',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }